import { FormControl, Select, MenuItem, Grid, FormHelperText } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

const LoanPurpose = ({ page, setPage, formData, setFormData }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const onLoanPurposeChange = (e) => {
        setFormData({ ...formData, productPurpose: e.target.value });
        setErrorMessage(null);
    }

    const updateFormData = useCallback(() => {
        setFormData(formData);
    },[formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setErrorMessage(null);
    }, [formData.lang]);

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Quel est l’objet de votre prêt?" : "What is the purpose for your loan?"}</div>
                <FormControl>
                    <Select
                        variant="outlined"
                        value={formData.productPurpose || ''}
                        onChange={(e) => onLoanPurposeChange(e)}
                    >
                        <MenuItem value={"Debt Consolidation"}>{formData.lang === "fr" ? "Consolidation de dette" : "Debt Consolidation"}</MenuItem>
                        <MenuItem value={"Credit Card Consolidation"}>{formData.lang === "fr" ? "Consolidation de cartes de crédit" : "Credit Card Consolidation"}</MenuItem>
                        <MenuItem value={"Car Repair"}>{formData.lang === "fr" ? "Réparation automobile" : "Car Repair"}</MenuItem>
                        <MenuItem value={"Home Improvement"}>{formData.lang === "fr" ? "Amélioration de l'habitat" : "Home Improvement"}</MenuItem>
                        <MenuItem value={"Utility Bill"}>{formData.lang === "fr" ? "Facture de services publics" : "Utility Bill"}</MenuItem>
                        <MenuItem value={"School Expenses"}>{formData.lang === "fr" ? "Frais scolaires" : "School Expenses"}</MenuItem>
                        <MenuItem value={"Vacation"}>{formData.lang === "fr" ? "Vacances" : "Vacation"}</MenuItem>
                        <MenuItem value={"Emergency Expense"}>{formData.lang === "fr" ? "Dépense d'urgence" : "Emergency Expense"}</MenuItem>
                        <MenuItem value={"Other"}>{formData.lang === "fr" ? "Autre" : "Other"}</MenuItem>
                    </Select>
                    <FormHelperText style={{ color: "red" }}>{errorMessage}</FormHelperText>
                </FormControl>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                if (formData.productPurpose === "") {
                                    setErrorMessage(formData.lang === "fr" ? "Veuillez sélectionner un objectif pour votre prêt." : "Please select a purpose for your loan.");
                                } else {
                                    window.dataLayer.push({'event': 'loan_step3', 'loanEvent': 'step3', 'loanEventID': 4});
                                    // quebec only
                                    // window.dataLayer.push({'event': 'loan_step3q', 'loanEvent': 'step3q', 'loanEventID': '4q'});
                                    setPage(page + 1);
                                }
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default LoanPurpose;